module.exports = __webpack_public_path__ + "media/recipes/159-ec7c69f0.png";